import React, { useEffect, useState } from "react";
import { client } from "@/lib/api";
import { toast } from "sonner";

// WW-214.g · AI calls go as direct requests; a failed one falls back to the short child process.
const box = { padding: 16, borderRadius: 14, border: "1px solid var(--ww-line)", background: "var(--ww-surface)" };
const btn = { padding: "10px 16px", borderRadius: 10, border: "1px solid var(--ww-line-strong)", background: "transparent",
  color: "var(--ww-text)", fontFamily: "Poppins", fontWeight: 700, fontSize: 13, minHeight: 40, cursor: "pointer" };

export const AiPathPanel = () => {
  const [s, setS] = useState(null);
  const load = () => client.get("/admin/ops/ai-path/status").then((r) => setS(r.data)).catch(() => toast.error("couldn't load"));
  useEffect(() => { load(); }, []);
  const flip = () => client.post("/admin/ops/ai-path/switch", { on: !s.direct }).then(load).catch(() => toast.error("failed"));
  const e = s?.last_error;
  return (
    <div data-testid="ops-card-ai-path" style={box}>
      <h2 style={{ fontFamily: "Poppins", fontWeight: 800, fontSize: 18 }}>WW-214.g · AI calls</h2>
      <p style={{ fontFamily: "Arial", fontSize: 13, color: "var(--ww-text-muted)", marginTop: 4 }}>
        page reading, poster vision, crop check, description rewrite and overlay scan go as one direct request each, one at a time. if a direct request fails, that one call falls back to the AI library in a short separate process.
      </p>
      {s && (
        <div className="mt-3" style={{ fontFamily: "Arial", fontSize: 13 }}>
          <p data-testid="ai-path-state">path: <b>{s.direct ? "direct" : "separate process for every call"}</b></p>
          <p data-testid="ai-path-counts">calls direct <b>{s.calls_direct}</b> · calls fallen back <b>{s.calls_fallen_back}</b>{s.calls_child_switch ? ` · by switch ${s.calls_child_switch}` : ""}</p>
          <p data-testid="ai-path-last-error" style={{ color: "var(--ww-text-muted)", overflowWrap: "anywhere" }}>
            last error: {e ? `${e.at.slice(0, 16).replace("T", " ")} UTC · ${e.model} · ${e.error}` : "none"}
          </p>
          <button data-testid="ai-path-toggle" style={{ ...btn, marginTop: 8 }} onClick={flip}>
            {s.direct ? "use the separate process for every call" : "go back to direct"}
          </button>
        </div>
      )}
    </div>
  );
};
